module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/axios/index.js
// module id = 139
// module chunks = 0